(function () {
  function normalizeName(str) {
    return (str || '').toString().trim().toLowerCase();
  }

  function optionValue(variant, pos) {
    if (pos === 1) return variant.option1;
    if (pos === 2) return variant.option2;
    return variant.option3;
  }

  function initBundle(root) {
    var dataScript = root.querySelector('[data-bundle-product-json]');
    if (!dataScript) return;

    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    var options = data.options || [];
    var variants = data.variants || [];

    var colorOption = options.filter(function (o) {
      var n = normalizeName(o.name);
      return n.indexOf('couleur') !== -1 || n.indexOf('color') !== -1;
    })[0];

    var sizeOption = options.filter(function (o) {
      var n = normalizeName(o.name);
      return n.indexOf('taille') !== -1 || n.indexOf('size') !== -1;
    })[0];

    if (!colorOption || !sizeOption) return;

    var colorPos = colorOption.position;
    var sizePos = sizeOption.position;
    var colorValues = colorOption.values;
    var sizeValues = sizeOption.values;

    var variantMap = {};
    var colorImages = {};

    variants.forEach(function (v) {
      var color = optionValue(v, colorPos);
      var size = optionValue(v, sizePos);
      variantMap[color + '||' + size] = v;
      if (!colorImages[color] && v.image) {
        colorImages[color] = v.image;
      }
    });

    var tiers = root.querySelectorAll('[data-bundle-tier]');
    var submitBtn = root.querySelector('[data-bundle-submit]');
    var messageBox = root.querySelector('[data-bundle-message]');

    function updateTierThumb(tier) {
      var thumb = tier.querySelector('[data-tier-thumb]');
      if (!thumb) return;
      var img = colorImages[colorValues[0]];
      if (img) thumb.setAttribute('src', img);
    }

    tiers.forEach(updateTierThumb);

    function buildRowsHtml(count) {
      var html = '';
      for (var i = 0; i < count; i++) {
        var defaultColor = colorValues[0];
        var defaultImage = colorImages[defaultColor] || '';
        html +=
          '<div class="bundle-offer__variant-row" data-row>' +
          '<div class="bundle-offer__variant-thumb"><img data-row-image' +
          (defaultImage ? ' src="' + defaultImage + '"' : '') +
          ' alt=""></div>' +
          '<select class="bundle-offer__select" data-row-color>' +
          colorValues
            .map(function (c) {
              return '<option value="' + c + '">' + c + '</option>';
            })
            .join('') +
          '</select>' +
          '<select class="bundle-offer__select" data-row-size>' +
          sizeValues
            .map(function (s) {
              return '<option value="' + s + '">' + s + '</option>';
            })
            .join('') +
          '</select>' +
          '</div>';
      }
      return html;
    }

    function renderTierRows(tier) {
      var container = tier.querySelector('[data-bundle-variants]');
      if (!container) return;
      var count = parseInt(tier.getAttribute('data-bundle-pieces'), 10) || 1;
      container.innerHTML = buildRowsHtml(count);

      container.querySelectorAll('[data-row]').forEach(function (row) {
        var colorSelect = row.querySelector('[data-row-color]');
        var img = row.querySelector('[data-row-image]');
        colorSelect.addEventListener('change', function () {
          var newImg = colorImages[colorSelect.value];
          if (newImg) img.setAttribute('src', newImg);
        });
      });
    }

    function selectTier(tier) {
      tiers.forEach(function (t) {
        t.classList.remove('is-selected');
      });
      tier.classList.add('is-selected');
      renderTierRows(tier);
      if (messageBox) messageBox.hidden = true;
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function (event) {
        if (event.target.closest('select')) return;
        selectTier(tier);
      });
    });

    var defaultTier = root.querySelector('[data-bundle-tier].is-selected') || tiers[0];
    if (defaultTier) selectTier(defaultTier);

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var activeTier = root.querySelector('[data-bundle-tier].is-selected');
        if (!activeTier) return;

        var rows = activeTier.querySelectorAll('[data-row]');
        var items = [];
        var missing = false;

        rows.forEach(function (row) {
          var color = row.querySelector('[data-row-color]').value;
          var size = row.querySelector('[data-row-size]').value;
          var variant = variantMap[color + '||' + size];
          if (!variant || !variant.available) {
            missing = true;
            return;
          }
          items.push({ id: variant.id, quantity: 1 });
        });

        if (missing || items.length === 0) {
          if (messageBox) {
            messageBox.textContent = data.errorLabel || 'Combinaison indisponible.';
            messageBox.hidden = false;
          }
          return;
        }

        submitBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            if (messageBox) {
              messageBox.textContent = data.addedLabel || 'Ajouté au panier';
              messageBox.hidden = false;
            }
            if (window.startBundleCartTimer) window.startBundleCartTimer();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            fetch('/cart.js')
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              });
          })
          .catch(function () {
            if (messageBox) {
              messageBox.textContent = data.errorLabel || 'Une erreur est survenue, réessayez.';
              messageBox.hidden = false;
            }
          })
          .finally(function () {
            submitBtn.disabled = false;
          });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-bundle-offer]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-bundle-offer]');
    if (root) initBundle(root);
  });
})();